<template>
	<div class="survey-final">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar survey />
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<div class="survey-final-intro">
				<span class="sub">Final Step</span>
				<h1>Thank you! To finish, please check and confirm your details below.</h1>
			</div>
			<div class="info-card-pass">
				<div class="info-card-head alt">
					<p class="head">My Details</p>
				</div>
				<div class="info-card no-title survey-final-card">
					<div class="info-card-wrap">
						<div class="row">
							<div class="col" :class="{ 'hidden': form.anonymous }">
								<span class="eyebrow">Name</span>
	                            <p class="p-strong" v-if="form.anonymous">Hidden</p>
                                <p class="p-strong" v-else>{{ profile.name }}</p>
							</div>
							<div class="col">
								<span class="eyebrow">Gender</span>
                                <p class="p-strong">{{ profile.gender ? profile.gender : 'N/A' }}</p>
							</div>
						</div>
						<div class="row">
                            <div class="col">
								<span class="eyebrow">Age Range</span>
	                            <p class="p-strong">{{ profile.age_range ? profile.age_range : 'N/A' }}</p>
							</div>
                            <div class="col" :class="{ 'hidden': form.anonymous }">
								<span class="eyebrow">Area of Birth</span>
                                <p class="p-strong" v-if="form.anonymous">Hidden</p>
	                            <p class="p-strong" v-else>{{ profile.area_of_birth ? profile.area_of_birth : 'N/A' }}</p>
							</div>
						</div>
						<div class="row">
                            <div class="col" :class="{ 'hidden': form.anonymous }">
								<span class="eyebrow">Current Rank</span>
                                <p class="p-strong" v-if="form.anonymous">Hidden</p>
	                            <p class="p-strong" v-else>{{ profile.rank ? profile.rank : 'N/A' }}</p>
							</div>
                            <div class="col">
								<span class="eyebrow">Current Vessel Type</span>
	                            <p class="p-strong">{{ profile.vessel_type ? profile.vessel_type : 'N/A' }}</p>
							</div>
						</div>
						<div class="row">
                            <div class="col" :class="{ 'hidden': form.anonymous }">
								<span class="eyebrow">Vessel Flag State</span>
                                <p class="p-strong" v-if="form.anonymous">Hidden</p>
	                            <p class="p-strong" v-else>{{ profile.vessel_flag_state ? profile.vessel_flag_state : 'N/A' }}</p>
							</div>
                            <div class="col">
								<span class="eyebrow">Length of Service</span>
	                            <p class="p-strong">{{ profile.length_of_service ? profile.length_of_service : 'N/A' }}</p>
							</div>
						</div>
						<div class="row">
							<div class="col full">
								<div class="terms">
									<span class="term-label">I agree to the terms and conditions</span>
									<b-field>
							            <b-switch type="is-success" v-model="form.terms"></b-switch>
							        </b-field>
								</div>
								<div class="terms">
									<span class="term-label">Submit Anonymously</span>
									<b-field>
							            <b-switch type="is-success" v-model="form.anonymous"></b-switch>
							        </b-field>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a class="final-link text-link text-link-grey" @click="$router.push('/my-profile/personal-information');">Update Personal Details &raquo;</a><br>
                <a class="final-link text-link text-link-grey" @click="$router.push('/my-profile/professional-information');">Update Professional Details &raquo;</a>
			</div><!-- info pass -->
			<div class="confirm-wrap">
				<Button class="btn btn-large btn-lightblue" text="Submit Survey" @click.native="storeSurvey"></Button>
				<a class="text-link text-link-grey" @click="$router.push({ name: 'SurveyTake' });">&laquo; Return to Survey</a>
			</div>
		</div>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
    import UserService from '@/services/UserService';
    import Button from '@/components/Button.vue';
    import SurveyService from '@/services/SurveyService';
	export default {
		name: 'SurveyTakeFinal',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			Button
		},
		data () {
	        return {
                profile: {},
                form: {
                    name: null,
                    gender: null,
                    age_range: null,
                    area_of_birth: null,
                    rank: null,
                    vessel_type: null,
                    vessel_flag_state: null,
                    length_of_service: null,
                    terms: false,
                    anonymous: false
                },
                modalUpdateDetailsHeight: '-588',
                showUpdateDetailsModal: true
	        };
	    },
	    methods: {
            storeSurvey () {
                if (!this.form.terms) {
                    alert('Please accept the terms and conditions');
                } else {
                    return SurveyService.storeSurvey(this.surveyId, {
                        terms: this.form.terms,
                        anonymous: this.form.anonymous
                    }).then(() => {
                        this.$router.push({ name: 'SurveyTakeFinalResult' });
                    });
                }
            },
            getProfile () {
                return UserService.getProfile().then((response) => {
                    this.profile = response.data;
                });
            }
        },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            surveyId () {
                return this.$store.state.surveyId;
            }
		},
		mounted () {
            if (!this.surveyId) {
                this.$router.push('/seafarers-happiness-index');
            }
            this.getProfile();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.modal-update-details {
		bottom: -588px!important;
	}
	.scroll-wrap {
		overflow: scroll;
    	height: 460px;
	}
	.modal-update-details {
		form {
			margin-top: 20px;
			padding-top: 0;
			margin-bottom: 80px;
			.field {
				margin-bottom: 25px;
			}
		}
	}
	.update-modal-text {
		text-align: left;
		margin-bottom: 30px;
	}
	.info-card-head {
		&.alt {
			padding: 23px 30px 20px;
		}
	}
	.confirm-wrap {
		margin-top: 50px;
		padding-bottom: 20px;
		.text-link {
			margin-top: 0;
		}
	}
	.final-link {
		margin-top: 15px;
	}
	.terms {
		display: flex;
		align-items: center;
		margin-top: 10px;
		justify-content: space-between;
		.field {
			margin-bottom: 0;
			label {
				margin-bottom: 0;
				margin-right: 0;
			}
		}
		.term-label {
			font-size: 15px;
			line-height: 19px;
			letter-spacing: -0.37px;
			font-weight: 600;
			color: #0A203D;
			margin-right: 20px;
		}
	}
	.survey-final {
		background: #EEF0F3;
		.content-wrap {
			background: #EEF0F3;
		}
	}
	.col.hidden {
		opacity: 0.25;
	}
	.info-card-head {
		.head {
			font-size: 17px;
			line-height: 20px;
			letter-spacing: -0.43px;
			font-weight: 600;
			color: #0A203D;
		}
	}
	.survey-final-card {
		background: #fff;
	}
	.survey-final-intro {
		max-width: 317px;
		width: 100%;
		margin: 10px auto 40px;
		.sub {
			font-size: 14px;
			color: #6D7A8B;
			letter-spacing: -0.41px;
			line-height: 19px;
			margin-bottom: 10px;
			display: block;
		}
		h1 {
			font-size: 26px;
			line-height: 31px;
			letter-spacing: -0.65px;
			color: #0A203D;
			font-weight: 600;
		}
	}
</style>
